export default /* css */ `
@keyframes brand-name {
  0% {
    transform: translate3d(-200%, 0, 0);
    opacity: 0;
  }
  25% {
    opacity: 1;
  }
  100% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}
@keyframes payoff {
  0% {
    transform: translate3d(-200%, 0, 0);
    opacity: 0;
  }
  25% {
    opacity: 1;
  }
  100% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}
:host {
  --ui-heading-h1-font-size: calc(var(--ui-sys-unit) * 80);
}
.heading {
  --ui-heading-h1-spacing-bottom: calc(var(--ui-sys-unit) * 8);
  display: block;
  animation: brand-name 0.8s forwards;
  transform: translate3d(0,0,0);
  opacity: 0;
}
.payoff {
  font-size: calc(var(--ui-sys-unit) * 36);
  font-family: var(--ui-sys-typescale-font-family-alt);
  animation: payoff 0.8s 0.2s forwards;
  transform: translate3d(-200%, 0, 0);
  opacity: 0;
  display: block;
}
.content {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

ui-page {
  max-width: 120rem;
}
`
